import axios from 'axios';

import { ConfigService } from './ConfigService';

const clientConfig = new ConfigService();

export async function checkGdprLocation() {
    try {
        const { data } = await axios.get(clientConfig.eventotronPrefix + '/gdpr');
        return data;
    } catch (e) {
        throw 'There was an error getting gdpr location.';
    }
}
